<template>
  <div class="content animate-route">
    <banner bgColor="#d2d2d2" :title="title">
      <img src="@/assets/images/cleaf_banner_contact.jpg" slot="image" style="width: 100%" />
      <div class="nav" slot="nav">
        <div class="list">
          <span class="title" :class="showMessage ? 'active' : ''" @click="onShowMessage">在线留言</span>
        </div>
        <div class="list">
          <span class="title" :class="showContact ? 'active' : ''" @click="onShowContact">联系方式</span>
        </div>
      </div>
    </banner>
    <template v-if="showMessage">
      <div class="animate-route">
        <div class="button">
          <div class="contact-button" @click="messageForm">
            <editor class="editor" theme="outline" size="20" fill="#fff" /><span class="text">我要留言</span>
          </div>
        </div>
        <div v-if="messageList.length > 0" class="contact">
          <div class="contact-list" v-for="item in messageList" :key="item.id">
            <div class="user-avatar">
              <img v-if="item.sex === '2'" src="~@/assets/images/contact_woman.jpg" />
              <img v-else src="~@/assets/images/contact_man.jpg" />
              <div class="user-name" :class="item.sex === '2' ? 'woman' : 'man'">{{ item.name }}</div>
            </div>
            <div class="contact-content">
              <div class="problem-title">
                <span class="title">咨询</span>{{ item.messageTitle }} <span class="date">| {{ item.createTime }}</span>
              </div>
              <div class="problem-text">{{ item.messageContent }}</div>
              <div class="reply"><span>回复</span>{{ item.replyTime }}</div>
              <div class="reply-content">
                {{ item.replyContent }}
              </div>
            </div>
          </div>
          <a-pagination
            class="pagination"
            v-model="pagination.pageNo"
            :pageSize="pagination.pageSize"
            :total="pagination.total"
            @change="pagination.onChange"
            show-less-items
            hideOnSinglePage
          />
        </div>
        <a-empty style="margin-bottom: 50px" v-else description="暂无数据" />
      </div>
      <!-- <a-empty style="margin-bottom: 50px" v-else description="暂无数据" /> -->
    </template>
    <template v-if="showContact">
      <div class="animate-route">
        <div class="contact-method">
          <div class="method-item">
            <img src="@/assets/images/contact_address.png" />
            <div class="text">
              <div class="title">地址</div>
              <div>上海徐汇·宜山路407号-1尚光徐汇中心金座903室</div>
            </div>
          </div>
          <div class="method-item">
            <img src="@/assets/images/contact_phone.png" />
            <div class="text">
              <div class="title">电话</div>
              <div>021-64692449</div>
            </div>
          </div>
          <div class="method-item">
            <img src="@/assets/images/contact_customer.png" />
            <div class="text">
              <div class="title">客服热线</div>
              <div>400-821-5227</div>
            </div>
          </div>
        </div>
        <div class="contact-address">
          <img src="~@/assets/images/contact_address.jpg" />
        </div>
      </div>
    </template>
    <template v-if="showMessageForm">
      <div class="message-form animate-route">
        <div class="title">我要留言</div>
        <a-form-model ref="form" :rules="rules" :model="form" :label-col="labelCol" :wrapper-col="wrapperCol">
          <a-form-model-item label="您所在区域" style="text-align: left" prop="area">
            <a-select v-model="form.area">
              <a-select-option v-for="item in areaList" :key="item.value" :value="item.value">{{
                item.title
              }}</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="您的称呼" style="text-align: left" prop="name">
            <a-input v-model="form.name" />
          </a-form-model-item>
          <a-form-model-item label="您的性别" style="text-align: left" prop="sex">
            <a-radio-group v-model="form.sex">
              <a-radio :value="2"> <img src="@/assets/images/contact_man.jpg" /> </a-radio>
              <a-radio :value="1"> <img src="@/assets/images/contact_woman.jpg" /> </a-radio>
            </a-radio-group>
          </a-form-model-item>
          <a-form-model-item label="联系方式" style="text-align: left" prop="contact">
            <a-input v-model="form.contact" />
          </a-form-model-item>
          <a-form-model-item label="邮件地址" style="text-align: left" prop="email">
            <a-input v-model="form.email" />
          </a-form-model-item>
          <a-form-model-item label="留言主题" style="text-align: left" prop="messageTitle">
            <a-input v-model="form.messageTitle" />
          </a-form-model-item>
          <a-form-model-item label="留言内容" style="text-align: left" prop="messageContent">
            <a-input v-model="form.messageContent" type="textarea" :auto-size="{ minRows: 3, maxRows: 5 }" />
          </a-form-model-item>
          <a-form-model-item label="验证码" style="text-align: left" prop="captcha">
            <a-input v-model="form.captcha" style="width: 70%; margin-right: 5%" />
            <img @click="getCheckCodeImg" :src="checkCodeImg" />
          </a-form-model-item>
        </a-form-model>
        <div>为了更好的为您提供服务，以上填写全部为必填项。谢谢！</div>
        <a-button :loading="loading" class="button" @click="addContact">发送留言</a-button>
      </div>
    </template>
  </div>
</template>
<script>
import Banner from '@/components/Banner'
import { Editor } from '@icon-park/vue'
import { getCheckCode, getMessageList, addMessage, getDictByCode } from '@/api'
export default {
  components: {
    Banner,
    Editor,
  },
  data() {
    return {
      title: {
        eng: 'CONTACT US',
        chs: '联系我们',
      },
      loading: false,
      showContact: false,
      showMessage: true,
      showMessageForm: false,
      labelCol: { span: 4 },
      wrapperCol: { span: 20 },
      checkCodeImg: null,
      form: {},
      codeKey: null,
      rules: {
        area: [{ required: true, message: '请选择您所在区域' }],
        name: [{ required: true, message: '请输入您的称呼' }],
        sex: [{ required: true, message: '请选择您的性别' }],
        email: [
          { required: true, message: '请输入邮件地址', trigger: 'blur' },
          {
            pattern: /^([\w]+\.*)([\w]+)@[\w]+\.\w{3}(\.\w{2}|)$/,
            message: '请输入正确的电子邮件!',
          },
        ],
        contact: [
          { required: true, message: '请输入联系方式', trigger: 'blur' },
          { pattern: /^1[3456789]\d{9}$/, message: '请输入正确的手机号码!' },
        ],
        messageTitle: [{ required: true, message: '请输入留言主题' }],
        messageContent: [{ required: true, message: '请输入留言内容' }],
        captcha: [{ required: true, message: '请输入验证码' }],
      },
      messageList: [],
      areaList: [],
      pagination: {
        pageNo: 1,
        pageSize: 10,
        total: 0,
        onChange: (page) => {
          this.pagination.pageNo = page
          this.getMessageData()
        },
      },
    }
  },
  created() {
    this.getMessageData()
    this.getAreaList()
  },
  methods: {
    getAreaList() {
      getDictByCode('area').then((res) => {
        if (res.success) {
          this.areaList = res.result
        }
      })
    },
    getMessageData() {
      getMessageList({ pageNo: this.pagination.pageNo, pageSize: this.pagination.pageSize }).then((res) => {
        if (res.success) {
          this.messageList = res.result.records
          this.pagination.total = res.result.total
        }
      })
    },
    onShowContact() {
      this.showContact = true
      this.showMessage = false
      this.showMessageForm = false
      this.getMessageData()
    },
    onShowMessage() {
      this.showMessage = true
      this.showContact = false
      this.showMessageForm = false
    },
    messageForm() {
      this.getCheckCodeImg()
      this.showMessageForm = true
      this.showContact = false
      this.showMessage = false
    },
    getCheckCodeImg() {
      this.codeKey = new Date().valueOf()
      getCheckCode(this.codeKey).then((res) => {
        if (res.success) {
          this.checkCodeImg = res.result
        }
      })
    },
    addContact() {
      this.$refs.form.validate((err) => {
        if (err) {
          this.loading = true
          addMessage({ ...this.form, checkKey: this.codeKey }).then((res) => {
            if (res.success) {
              this.$message.success('谢谢您的留言，我们会尽快审核并给您回复。')
              this.onShowContact()
            } else {
              this.getCheckCodeImg()
            }
            this.loading = false
          })
        }
      })
    },
  },
}
</script>
<style lang="stylus" scoped>
@import './index'
route()
.content
  .nav
    menu()
  .button
    overflow hidden
    width 1138px
    margin 0 auto
    .contact-button
      cursor pointer
      float right
      margin-top 54px
      width 134px
      height 37px
      background #666
      .text
        line-height 37px
        font-size 18px
        color #fff
      .editor
        margin-right 12px
        vertical-align middle
        display inline-block
  .contact
    width 1138px
    margin 0 auto
    .contact-list
      display flex
      width 1138px
      margin-top 26px
      border-top rgba(0, 0, 0, 0.2) 1px solid
      padding 28px 12px
      &:last-child
        border-bottom rgba(0, 0, 0, 0.2) 1px solid
        margin-bottom 30px
      .user-avatar
        margin-right 21px
        height 155px
        width 100px
        border 1px #dcdddd solid
        img
          padding 17px 13px
        .user-name
          height 24px
          line-height 24px
          font-size 14px
          color #fff
        .man
          background #6357a3
        .woman
          background #db264f
      .contact-content
        text-align left
        .problem-title
          margin-bottom 12px
          font-size 18px
          color #000
          .date
            font-size 14px
            color #666
          .title
            background #000
            color #fff
            font-size 14px
            padding 6px 8px
            margin-right 10px
      .problem-text
        font-size 16px
        margin-bottom 12px
      .reply
        margin-bottom 12px
        span
          background #666
          color #fff
          font-size 14px
          padding 6px 8px
          margin-right 10px
      .reply-content
        font-size 16px
        white-space pre-line
    .pagination
      margin 20px 0 50px 0
  .contact-method
    display flex
    justify-content center
    margin-top 100px
    .method-item
      display flex
      align-items flex-end
      text-align left
      font-size 18px
      margin 0 24px
      .text
        margin 8px
        .title
          line-height 30px
          color #000
  .contact-address
    margin 100px 0
  .message-form
    width 600px
    margin 0 auto
    margin-bottom 100px
    .title
      font-size 36px
      margin 80px 0 60px 0
    .button
      font-size 24px
      width 164px
      height 41px
      line-height 41px
      background #666
      color #fff
      margin 0 auto
      margin-top 50px
      cursor pointer
</style>
